// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".plan_container__2O6Op {\n  display: flex;\n  align-items: center;\n  margin-bottom: 5px; }\n  .plan_container__2O6Op .plan_key__3t9LO {\n    font-size: 11px;\n    margin-right: 7px; }\n  .plan_container__2O6Op .plan_value__39EKF {\n    font-weight: bold;\n    font-size: 12px; }\n    .plan_container__2O6Op .plan_value__39EKF::first-letter {\n      text-transform: uppercase; }\n\n.plan_root__2lvEt {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 20px;\n  background: #fff;\n  box-shadow: 2px 1px 11px 3px rgba(181, 181, 181, 0.4);\n  border-radius: 15px;\n  margin-top: 10px; }\n  .plan_root__2lvEt .plan_title__AI8KJ {\n    margin-top: 0; }\n  .plan_root__2lvEt .plan_pricingBtn__be4k3 {\n    cursor: pointer;\n    border-radius: 15px;\n    color: #fff;\n    border: none;\n    background: #343b4c;\n    font-size: 11px;\n    padding: 5px;\n    margin-top: 5px; }\n", ""]);
// Exports
exports.locals = {
	"container": "plan_container__2O6Op",
	"key": "plan_key__3t9LO",
	"value": "plan_value__39EKF",
	"root": "plan_root__2lvEt",
	"title": "plan_title__AI8KJ",
	"pricingBtn": "plan_pricingBtn__be4k3"
};
module.exports = exports;
